import styled from "styled-components";

const TakeActionWrap = styled.div`
  padding: 62px 0 108px;
`

export default TakeActionWrap